import api, { setShowErrorNotification } from "@utils/api";

export const login = async (email, password) => {
  setShowErrorNotification(false);
  return new Promise(async (resolve, reject) => {
    try {
      const {data} = await api.post('login', {email, password});
      resolve(data.data);
    } catch (error) {
      reject(error.response.data);
    }
  })
};

export const getMe = async () => {
  const { data } = await api.get('/me');
  return data.data;
};

export const forgotPassword = async (email) => {
  setShowErrorNotification(false);
  return new Promise(async (resolve, reject) => {
    try {
      await api.post('forgot-password', { email });
      resolve();
    } catch (error) {
      reject(error.response?.data || { message: 'Erro ao solicitar redefinição de senha.' });
    }
  });
};